module.exports = "/_next/static/videos/slide-3-823bb9765bf585678d6392fcc8c55cc2.webm";